import { render, staticRenderFns } from "./chemReviewLaw.vue?vue&type=template&id=0d3f0099"
import script from "./chemReviewLaw.vue?vue&type=script&lang=js"
export * from "./chemReviewLaw.vue?vue&type=script&lang=js"
import style0 from "./chemReviewLaw.vue?vue&type=style&index=0&id=0d3f0099&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3f0099')) {
      api.createRecord('0d3f0099', component.options)
    } else {
      api.reload('0d3f0099', component.options)
    }
    module.hot.accept("./chemReviewLaw.vue?vue&type=template&id=0d3f0099", function () {
      api.rerender('0d3f0099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewLaw.vue"
export default component.exports